import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { CollectionList } from '../../../domain/models/collection.state';
import { CollectionQueriesInterface } from '../../models/collection-public.port.models';
import { getCollectionList } from '../../state/selectors/collection.selectors';

@Injectable()
export class CollectionQueriesFacade implements CollectionQueriesInterface {
    constructor(private readonly store: Store) { }

    public getCollection$(): Observable<CollectionList> {
        return this.store.select(getCollectionList);
    }
}
